document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('year').textContent = new Date().getFullYear();
    // Smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach((a)=>{
        a.addEventListener('click', (e)=>{
            const href = a.getAttribute('href');
            if (!href || href === '#') return;
            const el = document.querySelector(href);
            if (!el) return;
            e.preventDefault();
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });
});

//# sourceMappingURL=wera.781c940a.js.map
